import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useMutation, gql } from 'urql'
import { Button } from '../components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../components/ui/card'
import { Logo } from '../components/logo'

const VERIFY_EMAIL_MUTATION = gql(`
  mutation VerifyEmail($token: String!) {
    verifyEmail(token: $token)
  }
`)

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [, verifyEmail] = useMutation(VERIFY_EMAIL_MUTATION)

  useEffect(() => {
    if (!token) {
      setStatus('error')
      return
    }
    verifyEmail({ token }).then((result) => {
      if (result.error || !result.data?.verifyEmail) {
        setStatus('error')
      } else {
        setStatus('success')
      }
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-primary/5 dark:bg-gray-900 p-4 gap-8">
      <div className="scale-150">
        <Logo />
      </div>
      <Card className="w-full max-w-md">
        {status === 'loading' && (
          <>
            <CardHeader>
              <CardTitle>Verifying your email…</CardTitle>
              <CardDescription>Just a moment.</CardDescription>
            </CardHeader>
          </>
        )}
        {status === 'success' && (
          <>
            <CardHeader>
              <CardTitle>Email verified!</CardTitle>
              <CardDescription>Your email address has been confirmed. If you signed up on the Buylog app, you can close this tab and switch back — it'll pick this up automatically.</CardDescription>
            </CardHeader>
            <CardFooter>
              <Button className="w-full" asChild>
                <Link to="/login">Sign in to continue</Link>
              </Button>
            </CardFooter>
          </>
        )}
        {status === 'error' && (
          <>
            <CardHeader>
              <CardTitle>Link invalid or expired</CardTitle>
              <CardDescription>
                This verification link is no longer valid. Sign in to request a new one.
              </CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col gap-2">
              <Button asChild className="w-full">
                <Link to="/dashboard">Go to Dashboard</Link>
              </Button>
              <Button variant="link" size="sm" asChild>
                <Link to="/login">Sign in</Link>
              </Button>
            </CardContent>
          </>
        )}
      </Card>
    </div>
  )
}
